function initializeReveal() {
  let targets = document.querySelectorAll('.reveal');

  let observer = new IntersectionObserver(function (entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        let delay = 100 * Array.from(targets).indexOf(entry.target);

        setTimeout(() => {
          entry.target.classList.add('visible');
        }, delay);
      }
    });
  });

  targets.forEach((target) => observer.observe(target));
}

document.addEventListener('DOMContentLoaded', initializeReveal);
